module.exports = __webpack_public_path__ + "mu.bd0bebf15482dc5182ac.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/mu.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/mu.svg
// module chunks = styles